<iframe width="100%" height="100%" [src]="urlSafe"></iframe>
